import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import MainNavbar from '../components/MainNavbar';
import MainFooter from '../components/MainFooter';
import ContactForm from '../components/ContactForm';

const Contact = () => {
  const [submitSuccess, setSubmitSuccess] = useState(false);
  
  const handleFormSuccess = () => {
    setSubmitSuccess(true);
  };

  // FAQ items for the sidebar
  const faqItems = [
    {
      question: "How quickly will I receive a response to my inquiry?",
      answer: "We typically respond to all inquiries within 24-48 business hours. For urgent technical issues, please select 'Technical Support' as your subject for faster assistance."
    },
    {
      question: "How do I export my designs to HTML/CSS?",
      answer: "After creating your design, navigate to the view details page and click the 'Export' button. You can choose between HTML/CSS, React components, or a shareable link format depending on your needs."
    },
    {
      question: "What happens after I use my free generations?",
      answer: "After using your 10 free generations, you'll be prompted to upgrade to one of our paid plans. We offer flexible monthly and annual subscription options to suit different needs and project sizes."
    }
  ];

  return (
    <div className="font-sans antialiased text-gray-900">
      {/* Navbar with contact as active page */}
      <MainNavbar activePage="contact" />
      
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-r from-yellow-500 via-orange-500 to-red-500 text-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-4">Contact Us</h1>
          <p className="text-xl mb-4 max-w-2xl mx-auto">
            Have a question or feedback? We'd love to hear from you!
          </p>
        </div>
      </section>
      
      {/* Contact Form Section */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Form */}
            <div>
              <h2 className="text-2xl font-bold mb-6">Get in Touch</h2>
              
              {submitSuccess ? (
                <div className="bg-green-50 border border-green-200 text-green-800 p-6 rounded-lg">
                  <h3 className="font-bold text-lg mb-2">Message Sent!</h3>
                  <p>Thank you for contacting us. We'll get back to you as soon as possible.</p>
                  <button 
                    onClick={() => setSubmitSuccess(false)}
                    className="mt-4 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors"
                  >
                    Send Another Message
                  </button>
                </div>
              ) : (
                <ContactForm onSuccess={handleFormSuccess} />
              )}
            </div>
            
            {/* FAQ Section */}
            <div>
              <h2 className="text-2xl font-bold mb-6">Frequently Asked Questions</h2>
              
              <div className="space-y-6">
                {faqItems.map((item, index) => (
                  <div key={index} className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                    <h3 className="font-semibold text-lg mb-2">{item.question}</h3>
                    <p className="text-gray-600">{item.answer}</p>
                  </div>
                ))}
                
                <div className="bg-gradient-to-br from-yellow-100 to-orange-100 p-6 rounded-lg border border-orange-200">
                  <div className="flex items-center mb-3">
                    <HelpCircle className="w-5 h-5 text-orange-500 mr-2" />
                    <h3 className="font-semibold text-lg">Need more help?</h3>
                  </div>
                  <p className="text-gray-700 mb-4">
                    Check our help center for answers to many more common questions.
                  </p>
                  <a 
                    href="/help" 
                    className="inline-flex items-center text-orange-500 hover:text-orange-600 font-medium"
                  >
                    Visit Help Center
                    <svg className="w-4 h-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Footer */}
      <MainFooter />
    </div>
  );
};

export default Contact;